module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/footer@2x_38917f.png";